import type { ReactNode } from 'react';

type QueryEmptyStateProps = {
  children: ReactNode;
};

/** Muted empty copy for list/query shells. */
export function QueryEmptyState({ children }: QueryEmptyStateProps) {
  return <p className="text-sm text-muted">{children}</p>;
}
